import axios from 'axios'
import { Toast } from 'vant'

const BASE_URL = process.env.NODE_ENV === 'development' ? '/yx' : 'https://mjhx.xzhouse.com.cn/'
const service = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    timeout: 60000
})
let loadingInstance = null
service.interceptors.request.use(
    config => {
        loadingInstance = Toast.loading({
            forbidClick: true,
            message: '加载中...',
            duration: 0,
        })
        return config
    },
    error => {
        Toast.fail('连接失败')
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        loadingInstance.clear()
        if (response.status === 200) {
            const data = response.data
            return data
        }
    },
    error => {
        loadingInstance.close()
        Toast.fail('请求超时')
        return Promise.reject(error)
    }
)

export default service